export default __webpack_public_path__ + "static/media/detail_mobile_5_1.78fb20ab.png";